import React, { PropsWithChildren } from 'react';

import './index.scss';

export interface QueryCardChipProps {
  accent?: boolean;
  dot?: boolean;
}

export default function QueryCardChip({
  accent, dot, children,
}: PropsWithChildren<QueryCardChipProps>) {
  return (
    <span className={`query-card-chip${accent ? ' query-card-chip-accent' : ''}`}>
      {dot && <span className="query-card-chip-dot" />}
      {children}
    </span>
  );
}
